import { motion } from "framer-motion";
import { cn } from "~/lib/utils";
import { useFontStyle } from "~/hook/useFontStyle";
import SocialMediaSection from "./SocialMediaSection";
import ContactForm from "./ContactForm";
import { useContactData } from "~/hook/useContactData";
import ClientOnly from "~/components/shared-components/ClentOnly";

const ContactSection = () => {
  const { medium, normalInter } = useFontStyle();
  const contactData = useContactData();

  const { pageContent } = contactData;

  return (
    <div className="max-w-7xl mx-auto px-4 py-2">
      <ClientOnly
        fallback={
          <div className="max-w-7xl mx-auto px-4 py-2">
            {/* Section Header - Static version without motion */}
            <div className="text-center mb-8 lg:mb-12">
              <p className={cn("text-textColorPrimary body_text_l max-w-3xl mx-auto", normalInter)}>{pageContent.contactSection.description}</p>
            </div>

            {/* Content Grid - Static version without motion */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
              {/* Left Side - Social Media */}
              <div className="order-2 lg:order-1">
                <SocialMediaSection />
              </div>

              {/* Right Side - Contact Form */}
              <div className="order-1 lg:order-2">
                <ContactForm />
              </div>
            </div>
          </div>
        }
      >
        {/* Section Header - With motion animation */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-center mb-8 lg:mb-12"
        >
          {/* <h2 className={cn("h2_heading text-textHeadingColor mb-4 ", medium)}>{pageContent.contactSection.title}</h2> */}
          <p className={cn("text-textColorPrimary body_text_l max-w-3xl mx-auto", normalInter)}>{pageContent.contactSection.description}</p>
        </motion.div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Left Side - Social Media */}
          <div className="order-2 lg:order-1">
            <SocialMediaSection />
          </div>

          {/* Right Side - Contact Form */}
          <div className="order-1 lg:order-2">
            <ContactForm />
          </div>
        </div>
      </ClientOnly>
    </div>
  );
};

export default ContactSection;
